import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { NextpageContext } from '../context/nextpage.context'

const Header = (props: any) => {
  const nextpage = useContext(NextpageContext)
  let sitename = nextpage.UI.options.sitename
  return (
    <React.Fragment>
        {props.children}
        <div id='sitename'>
          <a id='hallmark' href='/'></a>
          <div>
            <Link to='/'>{sitename}</Link>
          </div>
        </div>
    </React.Fragment>
  )
}

export default Header
